import { render, staticRenderFns } from "./TestUploadForm.vue?vue&type=template&id=fa10aeca&scoped=true&"
import script from "./TestUploadForm.vue?vue&type=script&lang=js&"
export * from "./TestUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa10aeca",
  null
  
)

export default component.exports